module.exports = __webpack_public_path__ + "img/op_five_steps_5.15599a90.png";